// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tn-exit-intent {
  position: fixed;
  inset: 0;
  background: rgba(10, 22, 40, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
  animation: tn-exit-fade 0.2s ease-out;
}

@keyframes tn-exit-fade { from { opacity: 0; } to { opacity: 1; } }

.tn-exit-intent__card {
  position: relative;
  background: #fff;
  color: #1f2937;
  border-radius: 12px;
  max-width: 440px;
  width: 100%;
  padding: 32px 28px 28px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  animation: tn-exit-rise 0.25s ease-out;
}

@keyframes tn-exit-rise {
  from { transform: translateY(16px) scale(0.98); opacity: 0; }
  to   { transform: translateY(0)    scale(1);    opacity: 1; }
}

.tn-exit-intent__close {
  position: absolute;
  top: 10px;
  right: 12px;
  border: none;
  background: transparent;
  font-size: 26px;
  line-height: 1;
  color: #6b7280;
  cursor: pointer;
  padding: 4px 8px;
}

.tn-exit-intent__close:hover { color: #111827; }

.tn-exit-intent__title {
  margin: 0 0 12px;
  font-size: 22px;
  font-weight: 700;
  color: #001F3F;
}

.tn-exit-intent__copy {
  margin: 0 0 20px;
  font-size: 14px;
  line-height: 1.55;
  color: #4b5563;
}

.tn-exit-intent__actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.tn-exit-intent__cta {
  background: #00a896;
  color: #fff;
  border-radius: 6px;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  border: none;
}

.tn-exit-intent__cta:hover { background: #008275; }

.tn-exit-intent__ghost {
  background: transparent;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 500;
  color: #4b5563;
  cursor: pointer;
  font-family: inherit;
}

.tn-exit-intent__ghost:hover { border-color: #9ca3af; color: #1f2937; }

@media (prefers-reduced-motion: reduce) {
  .tn-exit-intent,
  .tn-exit-intent__card { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/ExitIntentModal/ExitIntentModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,qCAAqC;AACvC;;AAEA,0BAA0B,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAElE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,2CAA2C;EAC3C,+EAA+E;EAC/E,sCAAsC;AACxC;;AAEA;EACE,OAAO,uCAAuC,EAAE,UAAU,EAAE;EAC5D,OAAO,oCAAoC,KAAK,UAAU,EAAE;AAC9D;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,+BAA+B,cAAc,EAAE;;AAE/C;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,YAAY;AACd;;AAEA,6BAA6B,mBAAmB,EAAE;;AAElD;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA,+BAA+B,qBAAqB,EAAE,cAAc,EAAE;;AAEtE;EACE;0BACwB,eAAe,EAAE;AAC3C","sourcesContent":[".tn-exit-intent {\n  position: fixed;\n  inset: 0;\n  background: rgba(10, 22, 40, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  padding: 20px;\n  animation: tn-exit-fade 0.2s ease-out;\n}\n\n@keyframes tn-exit-fade { from { opacity: 0; } to { opacity: 1; } }\n\n.tn-exit-intent__card {\n  position: relative;\n  background: #fff;\n  color: #1f2937;\n  border-radius: 12px;\n  max-width: 440px;\n  width: 100%;\n  padding: 32px 28px 28px;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  animation: tn-exit-rise 0.25s ease-out;\n}\n\n@keyframes tn-exit-rise {\n  from { transform: translateY(16px) scale(0.98); opacity: 0; }\n  to   { transform: translateY(0)    scale(1);    opacity: 1; }\n}\n\n.tn-exit-intent__close {\n  position: absolute;\n  top: 10px;\n  right: 12px;\n  border: none;\n  background: transparent;\n  font-size: 26px;\n  line-height: 1;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 4px 8px;\n}\n\n.tn-exit-intent__close:hover { color: #111827; }\n\n.tn-exit-intent__title {\n  margin: 0 0 12px;\n  font-size: 22px;\n  font-weight: 700;\n  color: #001F3F;\n}\n\n.tn-exit-intent__copy {\n  margin: 0 0 20px;\n  font-size: 14px;\n  line-height: 1.55;\n  color: #4b5563;\n}\n\n.tn-exit-intent__actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n}\n\n.tn-exit-intent__cta {\n  background: #00a896;\n  color: #fff;\n  border-radius: 6px;\n  padding: 10px 18px;\n  font-size: 14px;\n  font-weight: 500;\n  text-decoration: none;\n  cursor: pointer;\n  border: none;\n}\n\n.tn-exit-intent__cta:hover { background: #008275; }\n\n.tn-exit-intent__ghost {\n  background: transparent;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  padding: 10px 18px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #4b5563;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.tn-exit-intent__ghost:hover { border-color: #9ca3af; color: #1f2937; }\n\n@media (prefers-reduced-motion: reduce) {\n  .tn-exit-intent,\n  .tn-exit-intent__card { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
